module.exports = __webpack_public_path__ + "img/mpp.342f512.png";